
             const preguntas = [
    {  
        texto: "¿Qué tipo de clima prefieres?",
        opciones: {
           "Cálido": { cancun: 3, panama: 3, espana: 2, eeuu: 1, japon: 0, francia: 1, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/calido_f7dd48f7-3e75-4abb-af35-703c73f40e14.webp?v=1745271527"},
            "Templado": { cancun: 1, panama: 1, espana: 3, eeuu: 2, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/templado_2b2226bd-9845-41f8-8572-a4d525008d1f.webp?v=1745271527" },
            "Frío": { cancun: 0, panama: 0, espana: 2, eeuu: 3, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/frio_6a3e0e76-151a-4e93-bd5e-cf89538c517e.webp?v=1745271527" }
        }
    },
    {  
        texto: "¿Qué escenario disfrutas más?",
        opciones: {
            "Playa": { cancun: 3, panama: 3, espana: 1, eeuu: 1, japon: 0, francia: 0, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/playa_b06955ba-bfca-4b41-875a-3842f3249dba.webp?v=1745271527" },
            "Montañas": { cancun: 1, panama: 1, espana: 2, eeuu: 2, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/montana_b3acb5d5-c109-4db3-9b07-dcaeb3a8405c.webp?v=1745271527" },
            "Ciudades históricas": { cancun: 0, panama: 0, espana: 3, eeuu: 1, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/ciudades-historicas.webp?v=1745271527" }
        }
    },
    {  
        texto: "¿Qué actividad no puede faltar en tu viaje?",
        opciones: {
            "Explorar monumentos históricos": { cancun: 2, panama: 1, espana: 3, eeuu: 2, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/explorar-monumentos-historicos.webp?v=1745271527" },
            "Hacer compras": { cancun: 1, panama: 2, espana: 2, eeuu: 3, japon: 2, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/hacer-compras.webp?v=1745271527" },
            "Visitar museos": { cancun: 1, panama: 1, espana: 3, eeuu: 2, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/visitar-museos.webp?v=1745271527" }
        }
    },
    {  
        texto: "¿Cuál es tu plan ideal en la noche?",
        opciones: {
            "Espectáculo cultural o show en vivo": { cancun: 2, panama: 1, espana: 2, eeuu: 3, japon: 1, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/espectaculo-cultural.webp?v=1745271527" },
            "Fiesta y diversión": { cancun: 3, panama: 3, espana: 3, eeuu: 3, japon: 1, francia: 2, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/fiesta-y-diversion.webp?v=1745271527" },
            "Recorrer la ciudad": { cancun: 1, panama: 1, espana: 3, eeuu: 2, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/recorrer-la-ciudad.webp?v=1745271527" }
        }
    },
    {  
        texto: "¿Qué prefieres en cuanto a cultura y experiencias?",
        opciones: {
            "Historia y arquitectura": { cancun: 1, panama: 1, espana: 3, eeuu: 1, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/historia.webp?v=1745271527" },
            "Experiencias gastronómicas": { cancun: 2, panama: 2, espana: 3, eeuu: 2, japon: 3, francia: 3, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/experiencias-y-gastronomicas.webp?v=1745271527" },
            "Experiencias modernas": { cancun: 1, panama: 2, espana: 2, eeuu: 3, japon: 3, francia: 2, img: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/experiencias-modernas_164d4689-7c5c-479d-a6a0-1432099f091b.webp?v=1745271527" }
        }
    }
];

        let respuestas = [];
        let preguntaActual = 0;

        function mostrarPregunta() {
    const contenedor = document.getElementById("pregunta-container");
    contenedor.innerHTML = "";

    if (preguntaActual < preguntas.length) {
        const pregunta = preguntas[preguntaActual];
        const titulo = document.createElement("h2");
        titulo.textContent = pregunta.texto;
        contenedor.appendChild(titulo);

        Object.keys(pregunta.opciones).forEach(opcion => {
            const div = document.createElement("div");
            div.classList.add("opcion");

            const img = document.createElement("img");
            img.src = pregunta.opciones[opcion].img;
            img.alt = opcion;

            const descripcion = document.createElement("h4");
            descripcion.textContent = opcion; // Aquí se muestra el nombre de la opción
           

            div.appendChild(img);
            div.appendChild(descripcion); // Se agrega la descripción debajo de la imagen

            div.onclick = () => {
                respuestas.push(opcion);
                preguntaActual++;
                mostrarPregunta();
            };

            contenedor.appendChild(div);
        });
    } else {
        mostrarResultado();
    }
}

        function mostrarResultado() {
            let puntajes = { cancun: 0, panama: 0, espana: 0, eeuu: 0, japon: 0, francia: 0 };
            let imagenes = {
                cancun: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/cancun_9bf01012-5388-451b-ae48-5b4959c0544d.webp?v=1745271527",
                panama: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/panama_d6977a04-7f51-406c-9507-36e0b2b533f9.webp?v=1745271527",
                espana: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/espana_ae5fe33a-cea9-45eb-9acf-38422dc3b5ee.webp?v=1745271527",
                eeuu: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/eeuu.webp?v=1745271527",
                japon: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/japon.webp?v=1745271527",
                francia: "https://cdn.shopify.com/s/files/1/0775/7604/4862/files/francia_1a4e4928-efad-4f8f-a39f-36a67328b8af.webp?v=1745271527"
            };


            let nombresCorregidos = {
                cancun: "Cancún",
                panama: "Panamá",
                espana: "España",
                eeuu: "EE.UU.",
                japon: "Japón",
                francia: "Francia"
            };


            let lugaresRecomendados = {
        cancun: {
            lugares: [
               "🏖️ Playa Delfines - Arena blanca y aguas cristalinas",
                "🏛️ Chichén Itzá - Una de las 7 maravillas del mundo",
                "🐠 Isla Mujeres - Snorkel y arrecifes impresionantes",
                "🌿 Cenote Ik Kil - Nadar en un pozo natural mágico",
                "🎉 Coco Bongo - Increíble vida nocturna y shows en vivo"
            ],
          sim:{
              texto: 'Cancún desde USD$15 🌍 aquí',
              ctaUrl: 'https://www.conecty.co/pages/simcard-esim-mexico'
          },
            blog: {
                imagen: 'https://www.conecty.co/cdn/shop/articles/pasaporte-colombiano-ok.webp',
                texto: 'El Pasaporte Colombiano: Tu Llave al Mundo',
                ctaTexto: 'Lee el blog',
                ctaUrl: 'https://www.conecty.co/blogs/blog-viajero/como-obtener-pasaporte-colombiano'
            }
        },
        panama: {
            lugares: [
                "🚢 Canal de Panamá - Ingeniería impresionante",
                "🏘️ Casco Viejo - Centro histórico con bares y cultura",
                "🌳 Parque Metropolitano - Naturaleza en plena ciudad",
                "🏝️ San Blas - Islas paradisíacas con aguas turquesas",
                "🛍️ Albrook Mall - El centro comercial más grande de América"
            ],
          sim:{
              texto: 'Panamá desde USD$9 🌍 aquí',
              ctaUrl: 'https://www.conecty.co/pages/simcard-esim-panama'
          },
            blog: {
                imagen: 'https://www.conecty.co/cdn/shop/articles/BANNER_INICIAL_1.jpg?v=1710867384',
                texto: 'Viaja sin contratiempos: una guía completa para tu maleta de mano',
                ctaTexto: 'Leer artículo',
                ctaUrl: 'https://www.conecty.co/blogs/blog-viajero/guia-completa-para-equipaje-de-mano'
            }
        },
        espana:{
          lugares: [
            "⛪ La Sagrada Familia - Arquitectura icónica de Gaudí",
            "🏰 Alhambra de Granada - Historia y belleza morisca",
            "🍷 La Rioja - Excelentes vinos y gastronomía",
            "🎭 Plaza Mayor de Madrid - Cultura y tapeo",
            "🏝️ Islas Baleares - Playas de ensueño y fiesta"
        ],
          sim:{
              texto: 'España desde USD$5 🌍 aquí',
              ctaUrl: 'https://www.conecty.co/pages/simcard-esim-europa'
          },
          blog: {
                imagen: 'https://www.conecty.co/cdn/shop/articles/viajar-madrid-sim-internacional-ok.webp?v=1727278684',
                texto: 'Qué hacer cuando viajes a Madrid',
                ctaTexto: 'Leer artículo',
                ctaUrl: 'https://www.conecty.co/blogs/blog-viajero/que-hacer-cuando-viajes-a-madrid'
            }
        },
        eeuu: {
          lugares: [
            "🏙️ Times Square - Luces y vida nocturna en Nueva York",
            "🏜️ Gran Cañón - Uno de los paisajes más impresionantes",
            "🀀󸠠Disney World - Magia y diversión en Orlando",
            "🎸 Nashville - Capital de la música country",
            "🌉 Golden Gate - Icono de San Francisco"
        ],
          sim:{
              texto: 'EE.UU. desde USD$6 🌍 aquí',
              ctaUrl: 'https://www.conecty.co/pages/simcard-esim-usa'
          },
          blog: {
                imagen: 'https://www.conecty.co/cdn/shop/articles/lugares-imperdibles-en-usa_1.webp?v=1742490428',
                texto: 'Lugares imperdibles en Estados unidos que puedes conocer y compartir usando una sim',
                ctaTexto: 'Leer artículo',
                ctaUrl: 'https://www.conecty.co/blogs/blog-viajero/lugares-de-eeuu-que-puedes-conocer-con-una-sim'
            }
        },
        japon:{
          lugares:[
            "🗻 Monte Fuji - La montaña más icónica de Japón",
            "⛩️ Templo Fushimi Inari - Pasillos de torii rojos en Kioto",
            "🍣 Mercado de Tsukiji - El paraíso del sushi",
            "🏯 Castillo de Osaka - Historia samurái y arquitectura",
            "🌸 Shinjuku Gyoen - Parque con cerezos en primavera"
        ],
          sim:{
              texto: 'Japón desde USD$19 🌍 aquí',
              ctaUrl: 'https://www.conecty.co/pages/simcard-esim-japon'
          },
          blog: {
                imagen: 'https://www.conecty.co/cdn/shop/articles/sakura-en-japon_9ef71729-0474-4bc5-8861-34ed64f8aedf.webp?v=1743431847',
                texto: 'Sakura en Japón: Guía Completa para Ver los Cerezos en Flor',
                ctaTexto: 'Leer artículo',
                ctaUrl: 'https://www.conecty.co/blogs/blog-viajero/sakura-en-japon-guia-completa-para-ver-los-cerezos-en-flor'
            }
        },
        francia: {
          lugares:[
            "🗼 Torre Eiffel - El monumento más famoso del mundo",
            "🎨 Museo del Louvre - Hogar de la Mona Lisa",
            "🍇 Valle del Loira - Castillos y viñedos",
            "🥐 Montmartre - Arte y cafés parisinos",
            "🏖️ Costa Azul - Playas de lujo en el Mediterráneo"
        ],
          sim:{
              texto: 'Francia desde USD$5 🌍 aquí',
              ctaUrl: 'https://www.conecty.co/pages/simcard-esim-europa'
          },
          blog: {
                imagen: 'https://www.conecty.co/cdn/shop/articles/que-llevar-a-europa-ok.webp',
                texto: '¿Qué llevar a tu viaje a Europa? Guía completa de viaje',
                ctaTexto: 'Leer artículo',
                ctaUrl: 'https://www.conecty.co/blogs/blog-viajero/guia-completa-que-llevar-a-tu-viaje-en-europa'
            }
        }
    };

            respuestas.forEach((respuesta, index) => {
                let seleccion = preguntas[index].opciones[respuesta];
                for (let pais in seleccion) {
                    if (pais !== "img") {
                        puntajes[pais] += seleccion[pais];
                    }
                }
            });

            let destinoRecomendado = Object.keys(puntajes).reduce((a, b) => puntajes[a] > puntajes[b] ? a : b);

            document.getElementById("quiz-container").style.display = "none";
            document.getElementById("resultado-container").style.display = "block";
            document.getElementById("destino-recomendado").innerHTML = 
    'Tu destino ideal es: <h4>' + nombresCorregidos[destinoRecomendado] + '</h4>';
            document.getElementById("resultado-img").src = imagenes[destinoRecomendado];

            let recomendadosHTML = "<h3>📍 Lugares recomendados</h3><ul>";
            lugaresRecomendados[destinoRecomendado].lugares.forEach(lugar => {
                recomendadosHTML += "<li>" + lugar + "</li>";
            });
            recomendadosHTML += "</ul>";
            document.getElementById("lugares-recomendados").innerHTML = recomendadosHTML;


             

            let blog = lugaresRecomendados[destinoRecomendado].blog;

            let blogHTML = `
              <div class="blog-box" style="    margin-top: 5%;">
                <h3>📰 Blog recomendado</h3>
                <img src="${blog.imagen}" alt="${blog.texto}" style="width: 400px; border-radius: 12px;">
                <p><h5 class="titulo-blog">${blog.texto}</h5></p>
                <a href="${blog.ctaUrl}" target="_blank" class="boton-recomendado">${blog.ctaTexto}</a>
              </div>
            `;
            
            document.getElementById("blog-recomendado").innerHTML = blogHTML;

          let sim = lugaresRecomendados[destinoRecomendado].sim;
              let simHTML = `
              <div class="sim-box" style="margin-top: 5%;">
                <h3 class="titulo-sim">Compra tu SIM/eSIM</h3>
                <a href="${sim.ctaUrl}" target="_blank"><h5>${sim.texto}</h5></a>
              </div>
            `;
            document.getElementById("sim-recomendado").innerHTML = simHTML;
        }

    
            

   
          

        mostrarPregunta();
  